import React from 'react';
import { Globe, Video, PenTool, Palette, Users, Shield, CheckCircle2 } from 'lucide-react';
export function Promotion() {
  return <section className="pt-48 pb-32 px-6 max-w-7xl mx-auto" data-id="element-458">
      <div className="text-center mb-16" data-id="element-459">
        <h2 className="font-['Archivo_Black'] text-4xl md:text-6xl uppercase mb-6" data-id="element-460">
          Celebrity <span className="text-[#FFD700]" data-id="element-461">Promotion</span>
        </h2>
        <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-462">
          Elite marketing services designed to amplify your reach and dominate
          the cultural conversation.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-463">
        {[{
        name: 'Social Surge',
        price: '899',
        icon: Globe,
        desc: 'Full social media management and growth hacking.',
        features: ['Daily Content Posting', 'Engagement Groups', 'Influencer Outreach', 'Analytics Dashboard']
      }, {
        name: 'Content Factory',
        price: '1,499',
        icon: Video,
        desc: 'Professional reels, shorts, and TikTok production.',
        features: ['15 Custom Reels/mo', 'Professional Editing', 'Trending Audio Strategy', 'Cross-Platform Distribution']
      }, {
        name: 'The Blog Empire',
        price: '599',
        icon: PenTool,
        desc: 'SEO-optimized blogging and press releases.',
        features: ['4 Long-form Articles', 'Press Release Distribution', 'SEO Keyword Research', 'Fan Newsletter Sync']
      }, {
        name: 'Graphic Identity',
        price: '750',
        icon: Palette,
        desc: 'High-end visual assets for your brand.',
        features: ['Tour Posters', 'Album/Single Art', 'Social Templates', 'Brand Guidelines']
      }, {
        name: 'Engagement Pro',
        price: '1,200',
        icon: Users,
        desc: 'Massive engagement and community management.',
        features: ['Comment Moderation', 'DM Management', 'Fan Community Building', 'Viral Thread Creation']
      }, {
        name: 'Full Empire Suite',
        price: '3,999',
        icon: Shield,
        desc: 'The ultimate promotion package for top-tier talent.',
        features: ['Everything in all tiers', 'Dedicated Manager', 'Crisis Management', 'Priority Ad Placement'],
        popular: true
      }].map((pkg, i) => <div key={i} className={`p-8 rounded-2xl border ${pkg.popular ? 'bg-[#1A1A1A] border-[#FFD700] shadow-[0_0_40px_rgba(255,215,0,0.1)]' : 'bg-black/40 border-white/5'}`} data-id="element-464">
            <pkg.icon className="text-[#FFD700] mb-6" size={32} data-id="element-465" />
            <h3 className="text-2xl font-['Archivo_Black'] uppercase mb-2" data-id="element-466">
              {pkg.name}
            </h3>
            <p className="text-gray-500 text-xs font-bold uppercase mb-6" data-id="element-467">
              {pkg.desc}
            </p>
            <div className="mb-8" data-id="element-468">
              <span className="text-3xl font-['Archivo_Black']" data-id="element-469">
                ${pkg.price}
              </span>
              <span className="text-gray-500 text-sm" data-id="element-470">/mo</span>
            </div>
            <ul className="space-y-3 mb-8" data-id="element-471">
              {pkg.features.map((f, j) => <li key={j} className="flex items-center gap-2 text-sm text-gray-400" data-id="element-472">
                  <CheckCircle2 size={14} className="text-[#FFD700]" data-id="element-473" /> {f}
                </li>)}
            </ul>
            <button className={`w-full py-3 rounded font-bold uppercase tracking-widest transition-all ${pkg.popular ? 'bg-[#FFD700] text-black hover:bg-white' : 'bg-white/5 text-white border border-white/10 hover:bg-white/10'}`} data-id="element-474">
              Select Package
            </button>
          </div>)}
      </div>
    </section>;
}